import React from 'react';
import { Text } from './ui';

const colorTokens = {
    alabaster: '#EEEEE7',
    white: '#FFFFFF',
    oxfordBlue: '#1b263b',
    richBlack: '#0d1b2a',
    neutral: {
        0: '#FFFFFF',
        50: '#F9F8F6',
        900: '#0D0D0D'
    }
};

const PlaceSetting = ({ friend, post, onNameClick, onHover, isHovered }) => {
    const displayName = friend?.display_name || friend?.username || 'Unknown';
    const recipeTitle = post?.recipe_title || '';
    const hasPost = !!post;
    
    return (
        <button
            className={`w-full py-3 px-4 text-left transition-all duration-200 hairline ${
                !hasPost 
                    ? 'bg-neutral-0 opacity-40 cursor-default'
                    : isHovered 
                        ? 'bg-neutral-900' 
                        : 'bg-neutral-0 hover:bg-neutral-50'
            }`}
            onMouseEnter={() => hasPost && onHover(friend, post)}
            onClick={() => hasPost && onNameClick(friend)}
        >
            <div className="flex flex-col">
                <div 
                    className="font-mono text-sm uppercase tracking-wider"
                    style={{ color: isHovered && hasPost ? '#FFFFFF' : '#0D0D0D' }}
                >
                    {displayName}
                </div>
                {isHovered && hasPost && recipeTitle && (
                    <div 
                        className="font-mono text-xs uppercase tracking-wider mt-1"
                        style={{ color: '#FFFFFF', opacity: 0.6 }}
                    >
                        {recipeTitle}
                    </div>
                )}
            </div>
        </button>
    );
};

export default PlaceSetting;

